* > .root:first-child {
  padding-left: 30px;
  border-top-left-radius: inherit;
}

* > .root:last-child {
  padding-right: 30px;
  border-top-right-radius: inherit;
}

.root {
  display: block;
  position: relative;
  font-size: 15px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: 1;
  font-weight: bold;
  line-height: 1;
  padding: 15px 10px;
}

.root:not([disabled]) {
  padding-right: 20px;
  cursor: pointer;

  transition: 0.15s ease-in-out background-color;
}

.root:not([disabled]):hover {
  background: rgba(0, 0, 0, 0.1);
}

.icon {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);

  transition: 0.15s ease-in-out transform;
}

.icon svg {
  width: 20px;
  height: 20px;
}

.asc {
  transform: translateY(-50%) rotateZ(0);
}

.desc {
  transform: translateY(-50%) rotateZ(180deg);
}
